import { AxiosInstance } from "axios";
import { useQuery } from "react-query";

import { RiskTemplate } from "types";
import { useClient } from "utils/client";

const fetchRiskTemplates = async (client: AxiosInstance) => {
  const { data } = await client.get<RiskTemplate[]>("/risk-templates");

  return data;
};

export const useRiskTemplates = () => {
  const client = useClient();

  const { data: riskTemplates = [], isLoading: fetchInProgress } = useQuery(
    ["riskTemplates"],
    async () => await fetchRiskTemplates(client)
  );

  return {
    riskTemplates,
    fetchInProgress,
  };
};
